function reactiveStateObjKey(obj, key) {
  // let the state data reactive
  Vue.set(obj, key, "");
}
export default {
  namespaced: true,
  state: {
    url: `/api/advertisers`,
    advertisers: [],
  },
  getters: {
    getAdvertisers: (state) => state.advertisers,
    getAdvertiserById: (state) => (id) =>
      state.advertisers.find((advertiser) => advertiser._id === id),
  },
  mutations: {
    setAdvertisers: (state, data) => {
      state.advertisers = data;
    },
    insertAdvertiser: (state, data) => {
      state.advertisers.push(data);
    },
    reactiveAdvertiser: (state) => {
      state.advertisers = state.advertisers;
    },
    updateAdvertiserById: (state, { id, data }) => {
      let index = state.advertisers.findIndex(
        (advertiser) => advertiser._id === id
      );
      if (!state.advertisers[index].icon && data.icon) {
        reactiveStateObjKey(state.advertisers[index], "icon");
      }
      state.advertisers[index] = _.assign(state.advertisers[index], data);
    },
    insertCampaign: (state, { advertiserId, data }) => {
      let advIndex = state.advertisers.findIndex(
        (advertiser) => advertiser._id === advertiserId
      );
      state.advertisers[advIndex].campaigns.push(data);
    },
    updateCampaignById: (state, { advertiserId, id, data }) => {
      let advIndex = state.advertisers.findIndex(
        (advertiser) => advertiser._id === advertiserId
      );
      let index = state.advertisers[advIndex].campaigns.findIndex(
        (campaign) => campaign._id === id
      );
      state.advertisers[advIndex].campaigns[index] = _.assign(
        state.advertisers[advIndex].campaigns[index],
        data
      );
    },
  },
  actions: {
    async getAdvertisers({ commit, state }) {
      try {
        let res = await axios.get(state.url);
        commit("setAdvertisers", res.data);
      } catch (e) {
        throw e;
      }
    },
    async getAdvertiserById({ commit, state }, id) {
      try {
        let res = await axios.get(`${state.url}/${id}`);
        commit("insertAdvertiser", res.data);
      } catch (e) {
        throw e;
      }
    },
    async createAdvertiser({ commit, state }, setObj) {
      try {
        let res = await axios.post(state.url, setObj);
        commit("insertAdvertiser", res.data);
      } catch (e) {
        throw e;
      }
    },
    async updateAdvertiserById({ commit, state }, { id, setObj }) {
      try {
        await axios.put(`${state.url}/${id}`, setObj);
        commit("updateAdvertiserById", {
          id: id,
          data: setObj,
        });
      } catch (e) {
        throw e;
      }
    },
    async getCampaignById({ commit, state }, { advertiserId, id }) {
      try {
        let res = await axios.get(
          `${state.url}/${advertiserId}/campaigns/${id}`
        );
        commit("insertCampaign", { advertiserId, data: res.data });
      } catch (e) {
        throw e;
      }
    },
    async createCampaign({ commit, state }, { advertiserId, setObj }) {
      try {
        let res = await axios.post(
          `${state.url}/${advertiserId}/campaigns`,
          setObj
        );
        commit("insertCampaign", { advertiserId, data: res.data });
      } catch (e) {
        throw e;
      }
    },
    async updateCampaignById({ commit, state }, { advertiserId, id, setObj }) {
      try {
        await axios.put(`${state.url}/${advertiserId}/campaigns/${id}`, setObj);
        commit("updateCampaignById", {
          advertiserId,
          id,
          data: setObj,
        });
      } catch (e) {
        throw e;
      }
    },
  },
};
